export default "__VITE_ASSET__dN7DOhrX__"